import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { ChatWidgetComponent } from "./shared/chat-widget.component";
import { StreakCelebrationComponent } from "./shared/streak-celebration.component";
import { ToastStackComponent } from "./shared/toast-stack.component";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [
    RouterOutlet,
    ToastStackComponent,
    StreakCelebrationComponent,
    ChatWidgetComponent,
  ],
  template: `
    <router-outlet />
    <app-chat-widget />
    <app-streak-celebration />
    <app-toast-stack />
  `,
})
export class AppComponent {}
